import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { KeyEventUtil } from 'utils'

const DiasFormGroup = ({ iTouched, iError, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('nuevaletra-agregar-button', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='DIAS' htmlFor='input-dias' md={12} />
      <Col md={12}>
        <Field name='dias'>
          {({ field }) => (
            <Form.InputNumber {...field} id='input-dias' isInvalid={iTouched && iError} disabled={fIsSubmitting} onKeyDown={onKeyDown} />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DiasFormGroup)
